import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class ApplicationRoute extends Route 
{
	@service metrics;
	@service router;
	
    didTransition() 
	{
      	let router = this.router;
		const page = router.currentURL;
		const title = router.currentRouteName || 'unknown';

		this.metrics.trackPage({ page, title });

      	return true; // Bubble the didTransition event
    }
}
